import {
  actionTypes,
} from 'redux-resource';
import {
  ResourceType,
} from '../../types';

const customListPlugin = (resourceType: ResourceType) => (state, action) => {
  const {
    type,
    customLists,
    includedResources,
  } = action;

  if ([
    actionTypes.READ_RESOURCES_SUCCEEDED,
    actionTypes.CREATE_RESOURCES_SUCCEEDED,
    actionTypes.UPDATE_RESOURCES_SUCCEEDED,
  ].includes(type)) {
    if (!customLists) {
      return state;
    }
    const resourceTypes = Object.keys(customLists);
    if (!resourceTypes.includes(resourceType)) {
      return state;
    }

    const oldList = state.lists[customLists[resourceType]];
    const newList = includedResources[resourceType].map(
      r => r.id,
    );

    const newLists = {
      [customLists[resourceType]]: (oldList
        ? [...new Set([].concat(oldList, newList))]
        : newList
      ),
    };

    return {
      ...state,
      lists: {
        ...state.lists,
        ...newLists,
      },
    };
  }

  return state;
};

export default customListPlugin;
